export const theme = {
  colors: {
    primary: '#1e2a78',
    primaryDark: '#16205c',
    primaryLight: '#4f84c5',
    secondary: '#245fa3',
    accent: '#f02621',
    success: '#3ddc97',
    error: '#f87171',
    warning: '#f5b942',
    info: '#2a5fa8',
    
    // Neutral colors
    white: '#ffffff',
    gray50: '#0a0f1a',
    gray100: '#101726',
    gray200: '#162033',
    gray300: '#22304a',
    gray400: '#334564',
    gray500: '#50607e',
    gray600: '#7080a0',
    gray700: '#97a7c0',
    gray800: '#c5d0de',
    gray900: '#edf2f8',
    
    // Background colors
    background: '#0c1220',
    backgroundSecondary: '#121a2c',
    surface: '#182338',
    
    // Text colors
    textPrimary: '#f5f7fb',
    textSecondary: '#a9b4c8',
    textTertiary: '#7e8ca5',
  },
  
  spacing: {
    xs: '0.25rem',
    sm: '0.5rem',
    md: '1rem',
    lg: '1.5rem',
    xl: '2rem',
    '2xl': '3rem',
    '3xl': '4rem',
    '4xl': '6rem',
  },
  
  borderRadius: {
    none: '0',
    sm: '0.125rem',
    md: '0.375rem',
    lg: '0.5rem',
    xl: '0.75rem',
    '2xl': '1rem',
    '3xl': '1.5rem',
    full: '9999px',
  },
  
  shadows: {
    sm: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
    md: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
    lg: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
    xl: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
    '2xl': '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
  },
  
  fonts: {
    body: "'Noto Sans SC', 'Source Han Sans SC', 'PingFang SC', 'Microsoft YaHei', sans-serif",
    heading: "'Noto Serif SC', 'Source Han Serif SC', 'Songti SC', serif",
  },
  
  fontSizes: {
    xs: '0.75rem',
    sm: '0.875rem',
    md: '1rem',
    lg: '1.125rem',
    xl: '1.25rem',
    '2xl': '1.5rem',
    '3xl': '1.875rem',
    '4xl': '2.25rem',
    '5xl': '3rem',
  },
  
  fontWeights: {
    light: 300,
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
  },
  
  breakpoints: {
    sm: '640px',
    md: '768px',
    lg: '1024px',
    xl: '1280px',
    '2xl': '1536px',
  },
  
  transitions: {
    fast: '150ms ease-in-out',
    normal: '300ms ease-in-out',
    slow: '500ms ease-in-out',
  },
};
